import { MessageCircle, Truck, Sparkles, PackageCheck } from "lucide-react";
import { ChapterLabel, MaskReveal, Reveal } from "@/components/Reveal";

const STEPS = [
  {
    n: "01",
    title: "Book",
    description:
      "Fill in your quick details via WhatsApp — it takes less than a minute.",
    icon: MessageCircle,
  },
  {
    n: "02",
    title: "Pickup",
    description:
      "We collect your garments straight from your door, at a time that suits you.",
    icon: Truck,
  },
  {
    n: "03",
    title: "Clean & Care",
    description:
      "Professional cleaning, meticulous hand finishing and flawless pressing.",
    icon: Sparkles,
  },
  {
    n: "04",
    title: "Delivery",
    description:
      "Your clothes are returned fresh, protected and ready to wear.",
    icon: PackageCheck,
  },
];

export default function HowItWorks() {
  return (
    <section
      id="how-it-works"
      data-testid="how-it-works-section"
      className="relative bg-[#0E1420] py-28 sm:py-36"
    >
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <ChapterLabel index="01" title="How It Works" testId="chapter-how-it-works" tone="dark" />

        <h2 className="mt-8 max-w-3xl font-display text-4xl font-light leading-[1.08] tracking-tight text-[#F9F6F0] sm:text-5xl lg:text-6xl">
          <MaskReveal>From your door, to our care,</MaskReveal>
          <MaskReveal delay={0.12}>
            <em className="gold-text-bright font-medium italic">and back again.</em>
          </MaskReveal>
        </h2>

        <div className="relative mt-20 grid grid-cols-1 gap-14 sm:grid-cols-2 lg:grid-cols-4 lg:gap-10">
          <div
            aria-hidden
            className="absolute left-0 right-0 top-8 hidden h-px bg-gradient-to-r from-transparent via-[#D4AF37]/25 to-transparent lg:block"
          />
          <div
            aria-hidden
            className="absolute bottom-8 left-8 top-8 w-px bg-gradient-to-b from-transparent via-[#D4AF37]/25 to-transparent sm:hidden"
          />
          {STEPS.map((step, i) => {
            const Icon = step.icon;
            return (
              <Reveal key={step.n} delay={0.12 * i} className="relative">
                <div data-testid={`step-card-${step.n}`} className="group">
                  <div className="relative flex items-center">
                    <span className="flex h-16 w-16 items-center justify-center border border-[#D4AF37]/25 bg-[#0E1420] transition-[border-color,background-color] duration-500 group-hover:border-[#D4AF37]/70 group-hover:bg-[#1A2334]">
                      <Icon
                        className="h-6 w-6 text-[#D4AF37] transition-transform duration-500 group-hover:scale-110"
                        strokeWidth={1.25}
                      />
                    </span>
                    <span className="ml-5 font-display text-6xl font-light italic leading-none text-[#D4AF37]/15 transition-colors duration-500 group-hover:text-[#D4AF37]/35">
                      {step.n}
                    </span>
                  </div>
                  <h3 className="mt-8 font-display text-2xl font-medium text-[#F9F6F0]">
                    {step.title}
                  </h3>
                  <p className="mt-3 max-w-xs text-sm font-light leading-relaxed tracking-wide text-[#A8B0BC]">
                    {step.description}
                  </p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
